export const navItems =[
    {
        id:1,
        title:"Home",
        path:"./",
        cName:"nav-item"
    },
    {
        id:2,
        title:"Book a Table",
        path:"./Book a table",
        cName:"nav-item"
    },
    {
        id:3,
        title:"Dineout Pay",
        path:"./Dineout Pay",
        cName:"nav-item"
    },
    {
        id:4,
        title:"Dineout Passport",
        path:"./Dineout Passport",
        cName:"nav-item"
    },
    {
        id:5,
        title:"Super Saver",
        path:"./Super Saver",
        cName:"nav-item"
    }
]